export default __webpack_public_path__ + "static/media/LilNounsReadingNounCats.17ba6710.png";